import React, { useEffect, useState } from "react";

import { useGetAllPopupsAdmin, useUpdateAdminPopup } from "utils";

import { LANGUAGES, LANGUAGE_CODE } from "consts";

import { Popup, PopupRequest } from "models";

import { AdminHead, AdminTable, Button, Col, Flex, MainPage, Row, Typography, Message as message } from "components";

export const Popups = () => {
  const { mutate: updatePopups, isPending: isSavingPopups, isSuccess: isSavingSuccess } = useUpdateAdminPopup();
  const { data, isPending: isLoadingPopups } = useGetAllPopupsAdmin();

  const [tableData, setTableData] = useState<Popup[]>([]);

  const findPopupsMissingLanguageForEachType = (popupsPerType: Popup[]): PopupRequest[] => {
    if (popupsPerType.length === 0) return [];
    const missingLanguages: LANGUAGE_CODE[] = [];
    LANGUAGES.filter((language) => language.showOnAdmin).forEach((language) => {
      const popupHasLanguage = popupsPerType.filter((popup) => popup.language === language.code);
      if (popupHasLanguage.length === 0) {
        missingLanguages.push(language.code);
      }
    });
    if (missingLanguages.length === 0) return [];
    const { id: _id, ...templatePopup } = popupsPerType[0];
    return missingLanguages.map((languageCode) => ({ ...templatePopup, language: languageCode }));
  };

  const uploadMissingPopupsLanguages = () => {
    if (!data) return;
    const popupsToCreate: PopupRequest[] = [];
    data.forEach((data) => {
      popupsToCreate.push(...findPopupsMissingLanguageForEachType(data.popups));
    });
    if (popupsToCreate.length > 0) {
      updatePopups(popupsToCreate);
      return;
    }

    message({ content: "Nothing to updated", icon: "" });
  };

  useEffect(() => {
    if (!isLoadingPopups && !isSavingPopups && data) {
      const tableData = data.map((popupResponse) => popupResponse.popups[0]);
      setTableData(tableData);
    }
  }, [isLoadingPopups, isSavingPopups, data]);

  useEffect(() => {
    if (isSavingSuccess) message({ content: "All updated", icon: "tick" });
  }, [isSavingSuccess]);

  return (
    <MainPage loading={isLoadingPopups} pageName={"admin"}>
      <AdminHead
        headline={`${tableData.length} Popup Types`}
        description={
          <Flex align="center" vertical>
            <Flex vertical>
              <Typography variant="h6">Manage the content of in-app popups here.</Typography>
              <Typography variant="paragraph-m">
                You can update existing popups, but adding or deleting them is not allowed. Each row in the table represents a popup type (not a language). To
                edit translations, click the edit icon next to a popup. If a language version is missing, use the Auto Generate button to create it.
              </Typography>
            </Flex>
            <Button
              type="primary"
              loading={isLoadingPopups && isSavingPopups && !data}
              disabled={isLoadingPopups && isSavingPopups && !data}
              onClick={uploadMissingPopupsLanguages}
            >
              Auto Generate popups for missing languages
            </Button>
          </Flex>
        }
      />
      <Row>
        <Col>
          {/* @ts-expect-error convert to TS */}
          <AdminTable
            dataSource={tableData}
            config={{
              exclude: ["buttonLink", "buttonText", "summary", "content", "language", "video"],
              actions: [
                {
                  icon: "tabler/edit",
                  route: "/popup/update/",
                  tooltip: "Edit this popup",
                },
              ],
            }}
          />
        </Col>
      </Row>
    </MainPage>
  );
};
